import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function attention({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      strokeWidth="2"
      className={className}
    >
      <path
        fill="none"
        d="M9.15 7.831A2.976 2.976 0 0112 4v0a2.976 2.976 0 012.85 3.831l-1.563 5.211c-.07.234-.105.351-.159.447a1 1 0 01-.654.487C12.366 14 12.244 14 12 14v0c-.244 0-.366 0-.474-.024a1 1 0 01-.654-.487c-.054-.096-.09-.213-.16-.447L9.15 7.832z"
      ></path>
      <circle fill="none" cx="12" cy="19" r="2"></circle>
    </svg>
  );
}

export default attention;
